<template>
    <v-app>
        <v-navigation-drawer v-if="isLoggedIn" app>
            <v-toolbar>
                <v-list class="pa-0">
                    <v-list-tile avatar>
                        <v-list-tile-content>
                            <v-toolbar-title class="headline text-uppercase ">
                                <span style="color: #21398d;"><b>{{$t('message.title')}} </b></span>
                                <span class="font-weight-light">LabelManager</span>
                            </v-toolbar-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-list>
                <v-list-tile
                        v-for="item in items"
                        :key="item.title"
                        @click=""
                        :to="item.to"
                        router
                        exact
                        v-if="$gate.can(item.permission)"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title v-t="item.title"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar v-if="isLoggedIn" app>
            <v-spacer></v-spacer>
            <locale-changer></locale-changer>
            <v-btn
                    flat
                    @click="logout"
            >
                <span class="mr-2">Logout</span>
                <v-icon>open_in_new</v-icon>
            </v-btn>
        </v-toolbar>
        <v-content>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-content>
        <v-footer :fixed="fixed" app>
            <span></span>
        </v-footer>
        <loader></loader>
    </v-app>
</template>

<style>
    body {
        background-color: rgba(0, 0, 0, .87);
    }

    .v-card__title .v-text-field {
        margin-top: 0px;
        padding-top: 0px;
    }

</style>

<script>
    import Loader from './components/Loader';
    import LocaleChanger from './components/LocaleChanger';
    //import LocaleSwitcher from './components/LocaleSwitcher';
    import Vue from 'vue'
    import axios from 'axios'
    import VueAxios from 'vue-axios'

    export default {
        name: 'App',
        components: {Loader, LocaleChanger},
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            }
        },
        data() {
            return {
                fixed: false,
                items: [

                    {title: 'message.release', icon: 'dashboard', to: '/release-list', permission: 'read_releases'},
                    {title: 'message.openByMe', icon: 'dashboard', to: '/release-open', permission: 'read_releases'},
                    {title: 'message.releaseFlow', icon: 'account_box', to: '/release-flow-list', permission: 'manage_releaseFlows'},
                    {title: 'message.productGroup', icon: 'account_box', to: '/itemgroup-list', permission: 'manage_productCategories'},
                    {title: 'message.productType', icon: 'account_box', to: '/itemtypes-list', permission: 'manage_productTypes'},
                    {title: 'message.user', icon: 'account_box', to: '/user-list', permission: 'manage_users'},
                    {title: 'message.department', icon: 'account_box', to: '/department-list', permission: 'manage_departments'},
                    {title: 'message.product', icon: 'dashboard', to: '/product-list', permission: 'manage_products'},

                ]
            }
        },
        created: function () {

            // Add a request interceptor
            this.$store.state.httpClient.interceptors.request.use((config) => {
                this.$store.commit('loader', true);
                return config;
            }, function (error) {
                // Do something with request error
                return Promise.reject(error);
            });

            // Add a response interceptor
            this.$store.state.httpClient.interceptors.response.use((response) => {
                this.$store.commit('loader', false);
                return response;
            }, (error) => {
                this.$store.commit('loader', false);
                this.$router.push('/login');
                // Do something with response error
                return Promise.reject(error);
            });

        },
        methods: {
            logout: function() {
                this.$store.dispatch('logout');
            }
        }
    }
</script>
